export default "__VITE_ASSET__tYLQ7vIa__"